import { Directive, ElementRef, Input, Renderer2, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[lazyBg]'
})
export class LazyBgDirective implements OnInit, OnDestroy,OnChanges {
    @Input('lazyBg') bgImage!: string; // URL de la imagen de fondo
    private observer!: IntersectionObserver;

    constructor (private el: ElementRef, private renderer: Renderer2) { }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.bgImage && changes.bgImage.firstChange == false)
        {
            this.loadBackgroundImage();
        }

    }

    ngOnInit() {
        this.initObserver();
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private initObserver() {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    
                    this.loadBackgroundImage();
                    this.observer.disconnect(); // Deja de observar después de cargar
                }
            });
        });

        this.observer.observe(this.el.nativeElement);
    }

    private loadBackgroundImage() {
        if (!this.bgImage) {
            this.bgImage = '/assets/img/nube_cc_200x140.png';
        }
        this.renderer.setStyle(
            this.el.nativeElement,
            'background-image',
            `url(${this.bgImage})`
        );
    }
}
